import React, { useRef, useState, useEffect } from "react";
import { useInput } from "react-admin";
import { TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

export default function CustomCompanySelector(props) {
    const { resourcePath, resourceParam, source, filter, label = "", getOptionValue, getOptionLabel, style = {}, clearable = true, multiple = false, onSelect, limit = 10, customSort = ["id", "ASC"], organizationName, ...rest } = props;
    const { input: { onChange } } = useInput(props);
    //const notify = useNotify();

    const [selectedOption, setSelectedOption] = useState(multiple ? [] : null);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    const fetchParkingTimeout = useRef(null);

    const handleOnChange = (newValue) => {
        onChange(newValue);
        if (onSelect)
            onSelect(newValue);
    };

    const handleInputChange = (event, value) => {
        setSearchText(value);
    };

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: searchText }),
                sort: JSON.stringify(customSort),
                page: 1,
                perPage: limit
            }
            fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    setLoading(false);
                    if (responseJson.success) {
                        setOptions(responseJson.data);
                        if (responseJson.data.length === 1 && searchText === "")
                            onOptionSelect(null, responseJson.data[0]);
                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const onOptionSelect = (event, option) => {
        if (multiple) {
            if (option[option.length - 1] && option[option.length - 1].id === "All") {
                let tempOptions = options.slice(1);
                setSelectedOption(tempOptions);
                handleOnChange("All");
            } else {
                setSelectedOption(option);
                handleOnChange(option.map(getOptionValue));

            }
        } else {
            setSelectedOption(option);
            handleOnChange(option ? getOptionValue(option) : null);
        }
    };

    useEffect(() => {
        const filters = { name: organizationName };
        let params = {
            user_id: sessionStorage.getItem("user_id"),
            filter: JSON.stringify(filters)
        }
        fetch(`${config.HOST_NAME}/crm/v3/${resourcePath}?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setLoading(false);
                if (responseJson.success && responseJson.data && responseJson.data.length > 0) {
                    onOptionSelect(null, responseJson.data[0]);
                }
            })
            .catch((e) => {
                setLoading(false);
            });

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [searchText]);  // eslint-disable-line react-hooks/exhaustive-deps

    return <Autocomplete
        multiple={multiple}
        blurOnSelect
        disableClearable={!clearable}
        getOptionLabel={multiple ? (option => option.id === "All" ? "All" : getOptionLabel(option)) : getOptionLabel}
        getOptionSelected={(option, value) => option && getOptionValue(option) === getOptionValue(value)}
        loading={loading}
        noOptionsText="No Records"
        onInputChange={handleInputChange}
        options={options}
        renderInput={params => <TextField {...params} label={label} variant="outlined" size="small" />}
        onChange={onOptionSelect}
        value={selectedOption}
        style={style}
        {...rest}
    />;
}